/**
 * Fire Meta Pixel events only when consent is granted and fbq is available.
 * Used for conversion events (Purchase, ViewContent, InitiateCheckout) and
 * PageView on SPA route changes.
 */

function getCookieConsent() {
  try {
    const match = document.cookie.match(/cookie-consent=([^;]+)/);
    return match ? match[1] : "unk";
  } catch {
    return "unk";
  }
}

export function trackMetaPixelEvent(eventName, params) {
  if (getCookieConsent() !== "granted" || typeof window.fbq !== "function") {
    return;
  }
  if (params) {
    window.fbq("track", eventName, params);
  } else {
    window.fbq("track", eventName);
  }
}
